<div class="classic-page-container">
  <main id="main" class="container site-main">
    <div class="site-content">
      <div class="errorpage">
        <header>
          <h1>{{ 'fspro.front.error.four-zero-four.title' | translate }}</h1>
        </header>
        <section>
          <p>{{ 'fspro.front.error.four-zero-four.message_first_line' | translate }}</p>
          <p>{{ 'fspro.front.error.four-zero-four.message_second_line' | translate }}</p>
        </section>
      </div><!-- .box -->
    </div><!-- .site-content -->
  </main>
</div>
